import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "card__inner--paddingless"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { style: { "color": "var(--link-color)" } };
const _hoisted_4 = { key: 1 };
import { useConversationStore } from '@/stores/conversation';
import ConversationListItem from '@/components/ConversationListItem.vue';
import CoreService from "@/services/core.service";
import { Views } from "@/types/ConfigTypes";
import { ref, onMounted, computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConversationList',
    emits: ['clicked'],
    setup(__props, { emit: emits }) {
        const loaded = ref(false);
        const store = useConversationStore();
        // const lastMessage = computed((id) => {
        //   return store.getLastMessage(id)
        // })
        const fetchData = () => {
            loaded.value = false;
            // await ConversationService.fetchList()
            loaded.value = true;
        };
        const conversationClicked = (id) => {
            emits('clicked', id);
        };
        const archiveConversationBtnClicked = () => {
            CoreService.push(Views.ARCHIVED_CONVERSATIONS);
        };
        const conversations = computed(() => {
            return store.getConversations;
        });
        // const startNewConversation = () => {
        //   CoreService.push(Views.CONVERSATION, {new: true})
        // }
        onMounted(() => {
            if (!store.isListOfItemsLoaded) {
                fetchData();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                (_unref(store).getConversations.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(conversations), (conversation) => {
                            return (_openBlock(), _createElementBlock("div", {
                                key: conversation.id
                            }, [
                                _createElementVNode("div", {
                                    onClick: ($event) => (conversationClicked(conversation.id))
                                }, [
                                    _createVNode(ConversationListItem, { conversation: conversation }, null, 8, ["conversation"])
                                ], 8, _hoisted_2)
                            ]));
                        }), 128)),
                        (_unref(store).getArchivedCount)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "messenger__selection--hover text-align-center cursor-pointer",
                                onClick: archiveConversationBtnClicked,
                                style: { "border-top": "1px solid var(--border-separator-color)", "padding": "10px" }
                            }, [
                                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('common.buttons.show_archived_conversations', { count: _unref(store).getArchivedCount })), 1)
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : (!loaded.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createVNode(ConversationListItem, { skeleton: true }),
                            _createVNode(ConversationListItem, { skeleton: true })
                        ]))
                        : _createCommentVNode("", true)
            ]));
        };
    }
});
